import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
export const getI18nTextForSuiteCardV2 = ({
  productLevel,
  showProductLevelTitle
}) => {
  switch (productLevel) {
    case 'STARTER':
      return {
        title: showProductLevelTitle ? /*#__PURE__*/_jsx(FormattedMessage, {
          message: "merchCards.starterCard.title.productLevelTitle"
        }) : /*#__PURE__*/_jsx(FormattedMessage, {
          message: "merchCards.suiteTile.starterCard.title"
        }),
        description: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "merchCards.suiteTile.starterCard.description"
        })
      };
    default:
      return undefined;
  }
};
export const getI18nTextForSuiteCard = ({
  productLevel,
  showProductLevelTitle
}) => {
  switch (productLevel) {
    case 'STARTER':
      return {
        title: showProductLevelTitle ? /*#__PURE__*/_jsx(FormattedMessage, {
          message: "merchCards.starterCard.title.productLevelTitle"
        }) : /*#__PURE__*/_jsx(FormattedMessage, {
          message: "merchCards.suiteTile.starterCard.title"
        }),
        description: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "merchCards.suiteTile.starterCard.description"
        })
      };
    case 'PROFESSIONAL':
      return {
        title: showProductLevelTitle ? /*#__PURE__*/_jsx(FormattedMessage, {
          message: "merchCards.professionalCard.title.productLevelTitle"
        }) : /*#__PURE__*/_jsx(FormattedMessage, {
          message: "merchCards.suiteTile.professionalCard.title"
        }),
        description: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "merchCards.suiteTile.professionalCard.description"
        })
      };
    case 'ENTERPRISE':
      return {
        title: showProductLevelTitle ? /*#__PURE__*/_jsx(FormattedMessage, {
          message: "merchCards.enterpriseCard.title.productLevelTitle"
        }) : /*#__PURE__*/_jsx(FormattedMessage, {
          message: "merchCards.suiteTile.enterpriseCard.title"
        }),
        description: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "merchCards.suiteTile.enterpriseCard.description"
        })
      };
    default:
      return undefined;
  }
};
export const getI18nKeyOverrideForProductCard = apiName => {
  switch (apiName) {
    case 'marketing-plus-professional-bundle':
      return {
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "merchCards.productTile.marketing-plus-professional-bundle.title"
        }),
        description: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "merchCards.productTile.marketing-plus-professional-bundle.description"
        }),
        lowerTierPlus: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "merchCards.productTile.marketing-plus-professional-bundle.lowerTierPlus"
        })
      };
    case 'marketing-plus-enterprise-bundle':
      return {
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "merchCards.productTile.marketing-plus-enterprise-bundle.title"
        }),
        description: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "merchCards.productTile.marketing-plus-enterprise-bundle.description"
        }),
        lowerTierPlus: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "merchCards.productTile.marketing-plus-enterprise-bundle.lowerTierPlus"
        })
      };
    case 'crm-suite-starter-bundle':
      return {
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "merchCards.suiteTile.starterCard.title"
        }),
        description: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "merchCards.suiteTile.starterCard.description"
        })
      };
    case 'hubspot-free':
      return {
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "merchCards.suiteTile.freeCard.title"
        }),
        description: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "merchCards.suiteTile.freeCard.description"
        })
      };
    case 'core-seats-professional':
      return {
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "merchCards.productTile.core-seats-professional.title"
        }),
        description: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "merchCards.productTile.core-seats-professional.description"
        }),
        lowerTierPlus: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "merchCards.productTile.core-seats-professional.lowerTierPlus"
        })
      };
    case 'core-seats-enterprise':
      return {
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "merchCards.productTile.core-seats-enterprise.title"
        }),
        description: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "merchCards.productTile.core-seats-enterprise.description"
        }),
        lowerTierPlus: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "merchCards.productTile.core-seats-enterprise.lowerTierPlus"
        })
      };
    case 'commerce-hub-professional':
      return {
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "merchCards.productTile.commerce-hub-professional.title"
        }),
        description: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "merchCards.productTile.commerce-hub-professional.description"
        })
      };
    case 'commerce-hub-enterprise':
      return {
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "merchCards.productTile.commerce-hub-enterprise.title"
        }),
        description: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "merchCards.productTile.commerce-hub-enterprise.description"
        })
      };
    default:
      return undefined;
  }
};